import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingState: React.FC<{ message?: string }> = ({ message = 'Laden…' }) => (
  <div className="flex min-h-[240px] flex-col items-center justify-center gap-3 rounded-2xl border border-slate-100 bg-white p-12 shadow-sm">
    <Loader2 className="h-10 w-10 animate-spin text-indigo-500" aria-hidden />
    <p className="text-xs font-bold uppercase tracking-widest text-slate-400">{message}</p>
  </div>
);

export default LoadingState;
